import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/Header.css';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);

  // Load user from localStorage on component mount and after any storage changes
  useEffect(() => {
    const loadUser = () => {
      const userData = localStorage.getItem('user');
      if (userData) {
        setUser(JSON.parse(userData));
      } else {
        setUser(null);
      }
    };
    loadUser();
    // Optional: listen to storage changes (if user logs in/out in another tab)
    window.addEventListener('storage', loadUser);
    return () => window.removeEventListener('storage', loadUser);
  }, []);

  // Keep header state in sync after in-app navigation (login/logout in same tab)
  useEffect(() => {
    const userData = localStorage.getItem('user');
    setUser(userData ? JSON.parse(userData) : null);
    // Close menu on route change
    setMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuItemClick = (action) => {
    setMenuOpen(false);
    if (typeof action === 'function') {
      action();
    }
  };

  const handleSignOut = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    navigate('/');
  };

  return (
    <header className="header">
      <div className="logo" onClick={() => navigate('/')}>
        Skillarea Technician
      </div>

      {/* Only show header actions when logged in */}
      {user && (
        <>
          {/* Desktop menu (visible on larger screens) */}
          <nav className="desktop-menu">
            <button onClick={() => navigate('/contact')}>Contact Us</button>
            <button onClick={() => navigate('/billing')}>Billing &amp; Payment</button>
            {user?.role === 'hirer' && (
              <button onClick={() => navigate('/hirer/past-hires')}>Past Hires</button>
            )}
            <button onClick={() => navigate('/about')}>About Us</button>
            <button className="header-btn header-btn--ghost" onClick={handleSignOut}>
              Logout
            </button>
          </nav>

          {/* Hamburger icon (visible on mobile) */}
          <div className="hamburger" onClick={toggleMenu} aria-label="Open menu" role="button" tabIndex={0}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </>
      )}

      {/* Mobile dropdown menu */}
      {user && menuOpen && (
        <div className="mobile-menu">
          <button
            onClick={() => handleMenuItemClick(() => navigate('/contact'))}
          >
            Contact Us
          </button>
          <button onClick={() => handleMenuItemClick(() => navigate('/billing'))}>
            Billing &amp; Payment
          </button>
          {user?.role === 'hirer' && (
            <button onClick={() => handleMenuItemClick(() => navigate('/hirer/past-hires'))}>
              Past Hires
            </button>
          )}
          <button
            onClick={() => handleMenuItemClick(() => navigate('/about'))}
          >
            About Us
          </button>
          <button onClick={() => handleMenuItemClick(handleSignOut)}>Logout</button>
        </div>
      )}
    </header>
  );
}

export default Header;